import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, ShoppingCart, User } from "lucide-react";
import { useCart } from "@/contexts/CartContext";

const TABS = [
  { to: "/", label: "Pradžia", icon: Home, end: true },
  { to: "/parduotuve", label: "Parduotuvė", icon: LayoutGrid },
  { to: "/krepselis", label: "Krepšelis", icon: ShoppingCart, cart: true },
  { to: "/paskyra", label: "Paskyra", icon: User },
];

export default function MobileNav() {
  const { count } = useCart();
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white dark:bg-[#111A28] border-t border-gray-200 dark:border-gray-700 shadow-[0_-2px_12px_rgba(0,0,0,0.06)]" data-testid="mobile-nav">
      <div className="grid grid-cols-4">
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <NavLink
              key={t.to}
              to={t.to}
              onClick={() => { if (t.to === "/") window.scrollTo({ top: 0, behavior: "smooth" }); }}
              end={t.end}
              className={({ isActive }) => `relative flex flex-col items-center justify-center gap-0.5 py-2.5 text-[10px] font-medium transition-colors ${isActive ? "text-[#00B5E2]" : "text-gray-500 dark:text-gray-400"}`}
            >
              <span className="relative">
                <Icon size={22} strokeWidth={2} />
                {t.cart && count > 0 && (
                  <span className="absolute -top-1.5 -right-2.5 bg-[#00B5E2] text-white text-[9px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center">{count}</span>
                )}
              </span>
              {t.label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
